export const getToken = () => {
  const userdata = sessionStorage.getItem('userdata') || null;
  if (userdata !== null) {
    return JSON.parse(userdata).token;
  }
  return null;
};

export const clearToken = () => {
  sessionStorage.clear();
};

export const formatError = error => {
  if (error.graphQLErrors) {
    return error.graphQLErrors.map(err => err.message).join(';');
  }
  return error.message;
};



// WEBPACK FOOTER //
// ./src/utils.js